/**
 * Registro mecánico de recetas del renderer de rueda.
 *
 * No contiene recetas ni sabe qué juego las aporta. Los paquetes de juego y
 * las experiencias visuales registran datos durante su carga; el renderer
 * consume únicamente este contrato neutral.
 */
export const WHEEL_RECIPE_REGISTRY = Object.create(null);

export function registerWheelRecipe(code, recipe) {
    if (!code || !recipe) throw new TypeError('wheel recipe requires code and recipe');
    if (WHEEL_RECIPE_REGISTRY[code]) throw new Error(`wheel recipe already registered: ${code}`);
    WHEEL_RECIPE_REGISTRY[code] = recipe;
    return () => {
        if (WHEEL_RECIPE_REGISTRY[code] === recipe) delete WHEEL_RECIPE_REGISTRY[code];
    };
}
